import React, { useState } from "react";
import PF from "../assets/Kustoms-Sports.jpeg";
import PI from "../assets/Pi-Dogs.jpeg";
import Amarca from "../assets/Amarca.png";
import WA from "../assets/WeatherApp.jpeg";
import Inv from "../assets/Inventario.webp";
import Fed from "../assets/Federalito.webp";
import Fed2 from "../assets/Federalito2.webp";
import { trackProjectClick } from "../utils/analytics";

const Work = () => {
  const [selectedProject, setSelectedProject] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const projects = [
    {
      id: 2,
      year: "2023",
      title: "Kustoms-Sports E-Commerce",
      images: [PF],
      description:
        "E-commerce completo de productos deportivos. Sistema de carritos, pagos con Stripe, panel de administración con dashboard, gestión de productos, categorías y usuarios. Autenticación JWT con roles.",
      technologies: [
        "React",
        "Tailwind",
        "Node.js",
        "Express",
        "PostgreSQL",
        "Stripe",
        "Redux",
      ],

      demoLink: "https://kustoms-sports.vercel.app/",
      codeLink: "https://github.com/Abrahanm7/kustoms-sports.git",
      type: "E-Commerce Full Stack",
    },
    {
      id: 3,
      year: "2024",
      title: "Amarca Inmobiliaria",
      images: [Amarca],
      description:
        "Sitio web corporativo para inmobiliaria familiar. Diseño moderno con catálogo de propiedades, formulario de contacto funcional con backend propio, sección de servicios y valores. Aumentó visibilidad online y generación de leads.",
      technologies: ["React", "Tailwind", "Node.js", "Express"],
      metrics:
        "• Cliente real • SEO optimizado • Formulario con backend • Responsive design • Deployado en VPS (Ubuntu, Nginx)",
      demoLink: "https://www.amarcainmobiliaria.com.ar/",
      codeLink: "https://github.com/Abrahanm7/Amarca-App.git",
      type: "Corporate Website",
    },
    {
      id: 4,
      year: "2024",
      title: "Sistema Gestión de Inventario",
      images: [Inv],
      description:
        "Sistema de gestión interna para empresa de herramientas. Control de stock en tiempo real, préstamos con trazabilidad, generación de remitos PDF, dashboard con estadísticas. 3 roles: admin, encargado, operador. Cliente comercial activo.",
      technologies: [
        "React",
        "Node.js",
        "Express",
        "PostgreSQL",
        "JWT",
        "Roles",
      ],
      metrics:
        "• 500+ ítems gestionados • 3 roles de usuario • PDF automáticos • Dashboard con métricas • Deployado en VPS (Ubuntu, PM2, Nginx)",
      demoLink: null,
      codeLink: null,
      codeNote: "Código privado - Proyecto de cliente comercial activo",
      type: "Inventory Management",
    },
    {
      id: 5,
      year: "2024",
      title: "Sistema Escuela Federalito",
      images: [Fed, Fed2],
      description:
        "Sistema de gestión escolar integral para colegio privado. Gestión de 200+ alumnos en múltiples cursos, control de cuotas y moras automatizado. Integración AFIP para facturación electrónica (50+ facturas/mes). Panel de cajas con cierres diarios, 4 roles de usuario. Redujo tiempo de facturación en 80%.",
      technologies: [
        "React",
        "Node.js",
        "Express",
        "PostgreSQL",
        "AFIP API",
        "JWT",
        "Roles",
      ],
      metrics:
        "• 500+ alumnos • 100+ facturas/mes AFIP • 2 roles (admin y empleado) • Reducción 80% tiempo facturación • En producción en VPS (Ubuntu, PM2, Nginx)",
      demoLink: null,
      codeLink: null,
      codeNote:
        "Código privado - Sistema en producción con datos sensibles de menores",
      type: "School Management System",
    },
  ];

  const handleImageChange = (index) => {
    setSelectedImageIndex(index);
  };

  return (
    <div
      name="proyectos"
      className="w-full min-h-screen bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-slate-200 py-20 lg:py-24 transition-colors duration-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Mi Trayectoria
          </h2>
          <div className="w-24 h-1 bg-blue-600 dark:bg-blue-500 mx-auto mb-6"></div>
          <p className="text-lg sm:text-xl text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Explora mis proyectos a través del tiempo
          </p>
        </div>

        {/* Timeline - Desktop */}
        <div className="relative mb-12 hidden lg:block">
          <div className="flex justify-between items-center relative px-8">
            {/* Línea de tiempo */}
            <div className="absolute top-1/2 left-8 right-8 h-1 bg-blue-600 dark:bg-blue-500 transform -translate-y-1/2"></div>

            {projects.map((project, index) => (
              <div
                key={project.id}
                className="relative z-10 cursor-pointer"
                onClick={() => {
                  setSelectedProject(index);
                  setSelectedImageIndex(0);
                }}
              >
                <div
                  className={`w-6 h-6 rounded-full border-4 transition-all duration-300 ${
                    selectedProject === index
                      ? "bg-white dark:bg-slate-800 border-blue-600 dark:border-blue-500 scale-125"
                      : "bg-blue-600 dark:bg-blue-500 border-white dark:border-slate-800 hover:scale-110"
                  }`}
                ></div>
                <div className="absolute top-10 left-1/2 transform -translate-x-1/2 text-center whitespace-nowrap">
                  <span
                    className={`text-sm font-bold ${
                      selectedProject === index
                        ? "text-blue-600 dark:text-blue-400"
                        : "text-slate-700 dark:text-slate-300"
                    }`}
                  >
                    {project.year}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Timeline - Mobile */}
        <div className="lg:hidden mb-8">
          <div className="flex gap-2 overflow-x-auto pb-4 px-2 scrollbar-hide">
            {projects.map((project, index) => (
              <button
                key={project.id}
                onClick={() => {
                  setSelectedProject(index);
                  setSelectedImageIndex(0);
                }}
                className={`flex-shrink-0 px-4 py-2 rounded-full font-semibold transition-all duration-300 ${
                  selectedProject === index
                    ? "bg-blue-600 dark:bg-blue-500 text-white shadow-lg"
                    : "bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 border-2 border-slate-300 dark:border-slate-600"
                }`}
              >
                {project.year}
              </button>
            ))}
          </div>
        </div>

        {/* Proyecto seleccionado */}
        <div className="bg-white dark:bg-slate-700 rounded-2xl shadow-2xl dark:shadow-blue-500/10 p-6 sm:p-8 lg:p-10 transition-all duration-500">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
            {/* Imagen del proyecto */}
            <div className="order-1 lg:order-1">
              {projects[selectedProject].images.length > 0 ? (
                <div className="flex flex-col gap-4">
                  <div className="relative group">
                    <img
                      src={projects[selectedProject].images[selectedImageIndex]}
                      alt={projects[selectedProject].title}
                      className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-xl shadow-lg transition-transform duration-300 group-hover:scale-[1.02]"
                    />
                    {projects[selectedProject].images.length > 1 && (
                      <div className="absolute inset-0 flex items-center justify-between px-4">
                        <button
                          onClick={() =>
                            handleImageChange(
                              selectedImageIndex > 0
                                ? selectedImageIndex - 1
                                : projects[selectedProject].images.length - 1,
                            )
                          }
                          className="bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg hover:bg-white transition-all duration-300"
                        >
                          <svg
                            className="w-5 h-5 text-slate-800"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 19l-7-7 7-7"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() =>
                            handleImageChange(
                              selectedImageIndex <
                                projects[selectedProject].images.length - 1
                                ? selectedImageIndex + 1
                                : 0,
                            )
                          }
                          className="bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg hover:bg-white transition-all duration-300"
                        >
                          <svg
                            className="w-5 h-5 text-slate-800"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                  {projects[selectedProject].images.length > 1 && (
                    <div className="flex gap-2 justify-center">
                      {projects[selectedProject].images.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => handleImageChange(index)}
                          className={`px-3 py-1 rounded-full transition-all duration-300 text-sm font-medium ${
                            selectedImageIndex === index
                              ? "bg-blue-600 dark:bg-blue-500 text-white"
                              : "bg-slate-200 dark:bg-slate-600 text-slate-700 dark:text-slate-200 hover:bg-blue-400 dark:hover:bg-blue-500 hover:text-white"
                          }`}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div className="w-full h-64 sm:h-80 lg:h-96 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl shadow-lg flex items-center justify-center">
                  <span className="text-white text-2xl font-bold text-center px-4">
                    {projects[selectedProject].title}
                  </span>
                </div>
              )}
            </div>

            {/* Información del proyecto */}
            <div className="order-2 lg:order-2 flex flex-col justify-center">
              <div className="mb-6">
                <span className="inline-block text-blue-600 dark:text-blue-400 font-semibold text-xs sm:text-sm uppercase tracking-wider bg-blue-100 dark:bg-blue-900/50 px-3 py-1 rounded-full mb-3">
                  {projects[selectedProject].year} •{" "}
                  {projects[selectedProject].type}
                </span>
                <h3 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-4">
                  {projects[selectedProject].title}
                </h3>
              </div>

              <p className="text-slate-700 dark:text-slate-300 mb-6 leading-relaxed text-base sm:text-lg">
                {projects[selectedProject].description}
              </p>

              {/* Métricas e Impacto */}
              {projects[selectedProject].metrics && (
                <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-600 dark:border-blue-500 p-4 rounded-r-lg">
                  <p className="text-sm font-bold text-blue-900 dark:text-blue-300 mb-2 uppercase tracking-wider flex items-center gap-2">
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                    </svg>
                    Impacto & Métricas
                  </p>
                  <p className="text-slate-700 dark:text-slate-200 text-sm leading-relaxed">
                    {projects[selectedProject].metrics}
                  </p>
                </div>
              )}

              {/* Tecnologías */}
              <div className="mb-8">
                <h4 className="text-sm font-bold text-slate-900 dark:text-white mb-3 uppercase tracking-wider">
                  Stack Tecnológico
                </h4>
                <div className="flex flex-wrap gap-2">
                  {projects[selectedProject].technologies.map((tech, index) => (
                    <span
                      key={index}
                      className="bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-500 dark:to-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium shadow-md hover:shadow-lg transition-shadow duration-300"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              {/* Botones de acción */}
              <div className="flex flex-col gap-4">
                <div className="flex flex-col sm:flex-row gap-4">
                  {projects[selectedProject].demoLink && (
                    <a
                      href={projects[selectedProject].demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() =>
                        trackProjectClick(
                          projects[selectedProject].title,
                          "demo",
                        )
                      }
                      className="bg-blue-600 dark:bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 dark:hover:bg-blue-600 transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                    >
                      <span>Ver Demo</span>
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>
                    </a>
                  )}
                  {projects[selectedProject].codeLink && (
                    <a
                      href={projects[selectedProject].codeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() =>
                        trackProjectClick(
                          projects[selectedProject].title,
                          "github",
                        )
                      }
                      className="border-2 border-blue-600 dark:border-blue-500 text-blue-600 dark:text-blue-400 px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 dark:hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center justify-center gap-2"
                    >
                      <span>Ver Código</span>
                      <svg
                        className="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  )}
                </div>

                {/* Nota sobre código privado */}
                {projects[selectedProject].codeNote &&
                  !projects[selectedProject].codeLink && (
                    <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 dark:border-amber-600 p-4 rounded-r-lg">
                      <div className="flex items-start gap-3">
                        <svg
                          className="w-5 h-5 text-amber-600 dark:text-amber-500 flex-shrink-0 mt-0.5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <div>
                          <p className="text-sm font-semibold text-amber-900 dark:text-amber-300 mb-1">
                            Código Confidencial
                          </p>
                          <p className="text-xs text-amber-800 dark:text-amber-400 leading-relaxed">
                            {projects[selectedProject].codeNote}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* Navegación con flechas - Desktop */}
        <div className="flex justify-center mt-8 gap-4">
          <button
            onClick={() => {
              const newIndex =
                selectedProject > 0 ? selectedProject - 1 : projects.length - 1;
              setSelectedProject(newIndex);
              setSelectedImageIndex(0);
            }}
            className="bg-blue-600 dark:bg-blue-500 text-white p-3 rounded-full hover:bg-blue-700 dark:hover:bg-blue-600 transition-all duration-300 shadow-md hover:shadow-lg hover:scale-110"
            aria-label="Proyecto anterior"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <span className="flex items-center text-slate-700 dark:text-slate-300 font-medium">
            {selectedProject + 1} / {projects.length}
          </span>
          <button
            onClick={() => {
              const newIndex =
                selectedProject < projects.length - 1 ? selectedProject + 1 : 0;
              setSelectedProject(newIndex);
              setSelectedImageIndex(0);
            }}
            className="bg-blue-600 dark:bg-blue-500 text-white p-3 rounded-full hover:bg-blue-700 dark:hover:bg-blue-600 transition-all duration-300 shadow-md hover:shadow-lg hover:scale-110"
            aria-label="Proyecto siguiente"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Work;
